export default {
  titleFirstStep: {
    en: 'LESS THAN 15 SECONDS!',
  },
  title2Step: {
    en: 'WON’T TAKE LONG!',
  },
  title3Step: {
    en: 'HALF WAY THROUGH!',
  },
  title4Step: {
    en: 'ALMOST THERE!',
  },
  title5Step: {
    en: 'FINALLY!',
  },
  titleLastStep: {
    en: 'FINALLY!',
  },

  noteFirstStep: {
    en: 'How would you describe this scent? Click on tag to select it.',
  },
  noteNextStep: {
    en: 'How would you describe this perfume?',
  },
  noteSeasonStep: {
    en: 'What season is it perfect for?',
  },

  description: {
    en: `
    Please answer a couple of more questions about this scent.
    <br/>
    It will take less than 15 seconds.
  `,
  },
}
